import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, lifecycle, withHandlers } from 'recompose';

import { updateUser, deleteUser, fetchUser, clearBarbersByShop } from '../../actions';
import { getShops } from '../../../shops/reducers';
import { getUser } from '../../selectors';
import withNotifications from '../../../../common/withNotifications';
import { fetchShops } from '../../../shops/actions';
import confirmModal from '../../../../common/confirmModal';

const mapStateToProps = (state, props) => ({
  user: getUser(state, props.params.id),
  shops: getShops(state),
});

const mapDispatchToProps = {
  updateUser,
  deleteUser,
  fetchUser,
  fetchShops,
  clearBarbersByShop,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withNotifications,
  withRouter,
  lifecycle({
    componentWillMount() {
      if (this.props.params.id) {
        this.props.fetchUser(this.props.params.id);
      }
    },
  }),
  withHandlers({
    saveAndRedirect: props => data => props.updateUser(props.user.id, data)
      .then((user) => {
        const message = user.isAccountOwner
          ? 'This user has been updated to be the Account Owner.'
          : 'This user has been updated.';
        props.addNotification({
          title: 'Success',
          level: 'success',
          message,
        });

        props.router.push('/admin/users');
        props.clearBarbersByShop();
        props.fetchShops();
      }),
    onLogoutAllClick: props => async () => {
      const confirmed = await confirmModal({
        type: 'danger',
        title: 'Logout all sessions',
        message: 'Are you sure you want to logout all sessions?',
      });

      if (!confirmed) {
        return false;
      }

      return props.updateUser(props.user.id, { invalidateToken: true }).then(() =>
        props.addNotification({
          title: 'Success',
          level: 'success',
          message: 'All sessions logged out successfully.',
        })
      );
    },
    onDeleteClick: props => async () => {
      const confirmed = await confirmModal({
        type: 'danger',
        title: 'Delete user',
        message: 'Are you sure you want to delete this user?',
      });

      if (!confirmed) {
        return false;
      }

      return props.deleteUser(props.user.id).then(() => {
        props.addNotification({
          title: 'Success',
          level: 'success',
          message: 'User successfully deleted.',
        });

        return props.router.push('/admin/users');
      }
      );
    },
  })
);
